import React, { Component, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { arrayMove } from 'react-sortable-hoc';
import { Row, Col } from 'antd';
import { getState as globalState } from '@/reducers/Global/GlobalReducer';
import { setSortedNoteData } from '@/actions/GlobalAction';
import styles from './NotesContainer.scss';
import noteItemStyles from '../../components/NoteList/NoteItem/NoteItem.scss';

// actions and reducers
import { getNotes, sortNotes } from '../../actions/NotesAction';
import { getState as getNotebooksState } from '../../reducers/Notebooks/NotebooksReducer';

// container
import EditorContainer from '../EditorContainer/EditorContainer';

// component
import NotesWrapper from '../../components/NotesWrapper/NotesWrapper';

@connect(
  state => ({
    globalState: globalState(state),
    notebooks: getNotebooksState(state),
  }),
  dispatch => ({
    getNotes: (nbId, isForce = false, page = 1, count = 10, nid = null) => dispatch(getNotes(nbId, isForce, page, count, nid)),
    sortNotes: (oldSeq, newSeq, nbId) => dispatch(sortNotes(oldSeq, newSeq, nbId)),
    setSortedNoteData: data => dispatch(setSortedNoteData(data)),
  }),
)
export default class NotesContainer extends Component {
  componentWillReceiveProps(nextProps) {
    this.getNotes(nextProps);
  }

  getNotes = (props) => {
    const { nbId: nextId } = props.match.params;
    const { nbId: prevId } = this.props.match.params;

    // 选择不同的文集或刷新页面且指定nbId时，获取文章
    if ((nextId && nextId !== prevId)) {
      // 获取当前路由中的noteId作为nid参数
      const { noteId } = props.match.params;
      this.props.getNotes(nextId, false, 1, 10, noteId || null);
      return nextId;
    }
    return false;
  };

  onSortStart = () => {
    this.props.setSortedNoteData({
      isSorting: true,
    });
  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    const { notebooks, match } = this.props;
    const { params: { nbId } } = match;
    const oldSeq = notebooks.getIn(['entities', nbId, 'notes']).toJS();
    // 需要设置移动结束标志
    const sortedData = {
      isSorting: false,
    };
    // 如果光标在notebook item上，说明不是交换顺序，而是移动文章
    const sortingNote = this.props.globalState.get('sortingNote').toJS();
    if (sortingNote.isCursorOnNbItem) {
      // 需要设置移动了哪一篇文章，移动到新的notebook里
      sortedData.noteId = oldSeq[oldIndex];
      sortedData.nbId = nbId;
      sortedData.newNbId = sortingNote.newNbId;
    } else if (oldIndex !== newIndex) {
      // 只有顺序变了，才触发action
      const newSeq = arrayMove(oldSeq, oldIndex, newIndex);
      this.props.sortNotes(oldSeq, newSeq, nbId);
    }
    this.props.setSortedNoteData(sortedData);
  };

  hideDropDown = (e) => {
    if (document.body.click) {
      document.body.click(); // hidden the DropDown
    }
    const disabledElements = ['input', 'textarea', 'select', 'option', 'button'];
    return disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1;
  };

  render() {
    const { match } = this.props;
    return (
      <Fragment>
        <Col span={8} className={styles['notes-wrapper']}>
          <NotesWrapper
            distance={1}
            helperClass={noteItemStyles['note-item-dragging']}
            onSortEnd={this.onSortEnd}
            onSortStart={this.onSortStart}
            shouldCancelStart={this.hideDropDown}
          />
        </Col>
        <Route path={`${match.path}`} component={EditorContainer}/>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NotesContainer/NotesContainer.js